import React, { useState } from 'react';

import { Box } from '@mui/material';
import { Button } from 'semantic-ui-react';

import { OhsFormSettings, OhsFormLayoutType } from 'global-components/form/services/OhsFormModels';
import { OhsCusvalsRecordField } from 'global-services/constants/record-field/OhsGlobalRecordFiled';
import OhsFixedCategoryCusvalFieldsSectionContent from 'global-components/form/cusvals/OhsFixedCategoryCusvalFieldsSectionContent';

import { fullCusvalValueInvalid1 } from '../testData';

let renderCounter = 0;
function FixedCusvalNullDefId() {
  const [data, setData] = useState({});
  const ohsFormSettings = new OhsFormSettings(
    {
      category: 'Category 1',
      cusvals: fullCusvalValueInvalid1,
    },
    OhsFormLayoutType.AngularPageForm
  );

  renderCounter += 1;
  return (
    <Box width="100%">
      <p>When editing:</p>
      <p>1. cusvalId exists</p>
      <p>
        2. currentCusvalDefId <b>Not </b> exists
      </p>
      <p>3. cusvalValues exists</p>
      <p>4. cusvalValues have values that no longer exists in config</p>
      <p>Expected:</p>
      <p>
        When there are cusvals that have been removed in a config, but old record still has it,
        these fields will be labelled &quot;for deletion&quot;
      </p>

      <OhsFixedCategoryCusvalFieldsSectionContent
        ohsFormSettings={ohsFormSettings}
        id={OhsCusvalsRecordField.key}
        cusvalsConfig={[]}
        isInitCusvalConfigFetched
      />

      <Box mt={4} display="flex" justifyContent="end" width="100%">
        <Button
          id="submit"
          onClick={ohsFormSettings.useFormMethods.handleSubmit((formData: any) => {
            setData(formData);
          })}
          color="green"
        >
          Submit
        </Button>
      </Box>

      <div id="renderCount">Render Count: {renderCounter}</div>

      <pre>{JSON.stringify(data, null, 4)}</pre>
    </Box>
  );
}

export default FixedCusvalNullDefId;
